import {
  FLOW_SET_NAME,
  FLOW_SET_E2EFLOW,
  FLOW_SET_STATE_NAME,
  FLOW_SET_STATE_TRANSITIONS,
  FLOW_SET_STATE_VIEW_CONTENT,
  FLOW_SET_STATE_VIEW_OPTIONS,
  FLOW_SET_COMPANY_ICON,
  FLOW_SET_ERROR,
  FLOW_SET_COMPANY,
  FLOW_SET_COMPANY_COLOR
} from './types'

export default {
  [FLOW_SET_NAME]({ commit }, payload) {
    commit(FLOW_SET_NAME, payload)
  },

  [FLOW_SET_E2EFLOW]({ commit }, payload) {
    commit(FLOW_SET_E2EFLOW, payload)
  },

  [FLOW_SET_COMPANY_ICON]({ commit }, payload) {
    commit(FLOW_SET_COMPANY_ICON, payload)
  },

  [FLOW_SET_STATE_NAME]({ commit }, payload) {
    commit(FLOW_SET_STATE_NAME, payload)
  },

  [FLOW_SET_STATE_TRANSITIONS]({ commit }, payload) {
    commit(FLOW_SET_STATE_TRANSITIONS, payload)
  },

  [FLOW_SET_STATE_VIEW_CONTENT]({ commit }, payload) {
    commit(FLOW_SET_STATE_VIEW_CONTENT, payload)
  },

  [FLOW_SET_STATE_VIEW_OPTIONS]({ commit }, payload) {
    commit(FLOW_SET_STATE_VIEW_OPTIONS, payload)
  },

  [FLOW_SET_ERROR]({ commit }, payload) {
    commit(FLOW_SET_ERROR, payload)
  },

  [FLOW_SET_COMPANY]({ commit }, payload) {
    commit(FLOW_SET_COMPANY, payload)
  },

  [FLOW_SET_COMPANY_COLOR] ({ commit }, payload) {
    commit(FLOW_SET_COMPANY_COLOR, payload)
  }
}
